$(document).ready(function() {
	$('.cs-hero-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		responsive: [{
			breakpoint: 992,
			settings: {
				arrows: false,
				dots: true,
			}
		}]
	});
	$('.cs-featured-product-slider, .cstm-new-add-items').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		responsive: [{
			breakpoint: 1025,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
			}
		}]
	});

	$('.cs-brand-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 5,
		dots: false,
		arrows: true,
		infinite: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: true,
				arrows: false,
			}
		}]
	});

  $('.shopify-section').each(function() {
    if ($(this).find('.jdgm-carousel-wrapper').length > 0) {
      $(this).addClass('cs-review-main-sec');
    }
  });

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  const bottomOffset = 60; // pixels from bottom
  return (
    rect.top < window.innerHeight - bottomOffset &&
    rect.bottom > 0
  );
}

function checkInView() {
  $('.product-info__block-item.product-info__block-item--buy-buttons').each(function () {
    const $el = $(this);
    if (isInViewport(this)) {
      $el.addClass('in-view');
    } else if (this.getBoundingClientRect().bottom < window.innerHeight) {
      // Keep the class if the element is near the bottom of the page
      $el.addClass('in-view');
    } else {
      $el.removeClass('in-view');
    }
  });
}

// Check on scroll and on load
$(window).on('scroll resize', checkInView);
checkInView();


// Product page pop-up
$('.cstm-enquiry_button-pop-up').hide();
$('.cstm-enquiry-btn').click(function (e) {
    e.preventDefault();
    $('.cstm-enquiry_button-pop-up').show();
	$('body').addClass('product-popup');
});
$('.cstm-close-btn').click(function (e) {
    e.preventDefault();
    $('.cstm-enquiry_button-pop-up').hide();
	$('body').removeClass('product-popup');
});
  
});


var swiper = new Swiper('.mySwiper.cs-marquee-slider', {
	slidesPerView: 'auto',
	spaceBetween: 30,
	freeMode: true,
});
let sliderInitialized = false;

function initializeSlick() {
	if ($(window).width() <= 991) {
		if (!sliderInitialized) {
			$('.cs-shop-category-row').slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
				dots: true,
				responsive: [{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});
			sliderInitialized = true;
		}
	} else {
		if (sliderInitialized) {
			$('.cs-shop-category-row').slick('unslick');
			sliderInitialized = false;
		}
	}
}
$(document).ready(initializeSlick);
$(window).on('resize', initializeSlick);